module.exports = __webpack_public_path__ + "media/images/flags/il-2eea09d0c30825e287a10d1eac2eeec5.svg";